export const blockIconsSocialShareNew = (
	<span className='material-symbols-outlined'>share</span>
);
